import { requestWithLocalErrorHandling } from '@/common/services/request';

export async function signInWithFeishuJssdkCode(code) {
  return requestWithLocalErrorHandling('/auth/feishu/jssdk-sign-in', {
    method: 'POST',
    data: {
      code,
    },
  });
}
